import {Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {addClassName, removeClassName} from '../../../utils/dom-helpers';

// declare var $: any;

@Directive({
  selector: '[select2]'
})
export class Select2Directive implements OnInit, OnDestroy {

  @Input()
  public options = {};
  @Input()
  public data = [];
  @Output()
  public change = new EventEmitter();
  @Output()
  public closing = new EventEmitter();
  @Output()
  public selectChange = new EventEmitter();

  constructor(private el: ElementRef) {
    addClassName(this.el.nativeElement, ['sa-cloak', 'sa-hidden'])
  }

  ngOnDestroy(): void {
    // directive로 생성된 element가 ngIf에서 완전히 없어지지 않는 버그를 픽스함 예)Ad Instagram
    // console.log('destroy origin select element', this.el.nativeElement);
    // console.log('destroy select2 directive element', this.el.nativeElement.nextElementSibling);
    $(this.el.nativeElement.nextElementSibling).remove();
  }

  ngOnInit() {
    System.import('script-loader!select2/dist/js/select2.js').then(() => {
      const templateResultGenertator = (state) => {
        if (!state.id) {
          return state.text;
        }

        let _template = $('<div>' + state.text + '</div>');
        if (state.element) {
          const thumbnail = $(state.element).attr('thumbnail');
          const subtext = $(state.element).attr('subtext');
          console.log()
          if (thumbnail && subtext) {
            _template = $('<div><img src="' + thumbnail + '" style="width:40px;height:40px;margin-bottom:5px;margin-right:5px;float:left"><div><span>' + state.text + '</span></div>' +
              '<div style="color:gray">' + subtext + '</div></div>');
          } else {

            if (thumbnail) {
              _template = $('<div><img src="' + thumbnail + '" style="width:25px;height:25px;margin-bottom:5px;margin-right:5px">' + state.text + '</div>');
            }

            if (subtext) {
              _template = $('<div><span>' + state.text + '</span></div>' + '<div style="color:gray">' + subtext + '</div>');
            }
          }
        }
        return _template;
      }

      const templateSelectionGenertator = (state) => {
        if (!state.id) {
          return state.text;
        }

        let _template = $('<div>' + state.text + '</div>');
        if (state.element) {
          const thumbnail = $(state.element).attr('thumbnail');
          console.log()
          if (thumbnail) {
            _template = $('<div><img src="' + thumbnail + '" style="width:25px;height:25px;margin-bottom:5px;margin-right:5px">' + state.text + '</div>');
          }
        }
        return _template;
      }

      this.options['templateSelection'] = templateSelectionGenertator;

      this.options['templateResult'] = templateResultGenertator;
      this.options['width'] = '100%';
      const _select2 = $(this.el.nativeElement).select2(this.options);
      _select2.on('change', (e) => {
        // console.log('Select2- change- 값이 변경됐어!!!', e);
        this.change.emit(e);
        this.selectChange.emit(e);
      });
      _select2.on('select2:closing', (e) => {
        this.closing.emit(e);
      })

      removeClassName(this.el.nativeElement, ['sa-hidden']);
    })

  }


}



// WEBPACK FOOTER //
// ./src/app/shared/forms/input/select2/select2.directive.ts